<template>
	<div class="rateContainer">
		<div v-if="rateScore==0">
			<div class="stars">
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
			</div>
		</div>
		<div v-if="rateScore==1">
			<div class="stars">
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
			</div>
		</div>
		<div v-if="rateScore==2">
			<div class="stars">
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
			</div>
		</div>
		<div v-if="rateScore==3">
			<div class="stars">
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
			</div>
		</div>
		<div v-if="rateScore==4">
			<div class="stars">
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star2.png" alt="" class="star_img" />
			</div>
		</div>
		<div v-if="rateScore==5">
			<div class="stars">
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
				<img src="./../assets/image/star.png" alt="" class="star_img" />
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'Rate',
		props: {
			rateScore: {
				type: [Number, String], // 同时支持数字、字符串
				required: true,
				// 关键：自动转成数字
				validator: (val) => !isNaN(Number(val)),
				default: 0
			},
		},

		data() {
			return {
				rateArr: [{
						rateScore: 1,
						isChecked: false,
						classStr: "",
					},
					{
						rateScore: 2,
						isChecked: false,
						classStr: "",
					},
					{
						rateScore: 3,
						isChecked: false,
						classStr: "",
					},
					{
						rateScore: 4,
						isChecked: false,
						classStr: "",
					},
					{
						rateScore: 5,
						isChecked: false,
						classStr: "",
					},
				],
				childRateScore: this.rateScore
			}
		},
		created() {
			console.log(this.rateScore)
			// 遍历评分数组，分配评分文字和默认选中
			this.rateArr.forEach((item, index) => {
				if (item.rateScore == this.rateScore) {
					for (let i = 0; i <= index; i++) {
						this.rateArr[i].isChecked = true;
						this.rateArr[i].classStr = this.checkedIcon;
					}
				} else {
					item.isChecked = false;
					item.classStr = this.unCheckedIcon;
				}
			});
		},
		methods: {}
	}
</script>

<style scoped>
	.stars {
		display: flex;
	}

	.rateContainer {
		display: flex;
		align-items: center;
	}

	.rateItem {
		display: inline-block;
		/* padding-right: 10px; */
		transform: scale(0.8);
	}

	.iconfont {
		cursor: pointer;
	}

	.rateText {
		color: #333;
		font-size: 14px;
	}
	.star_img{
		width: 12px;
		height: 12px;
		margin-right: 2px;
	}
</style>